import { render } from "./EditorPanel.vue?vue&type=template&id=6e339a89"
import script from "./EditorPanel.vue?vue&type=script&lang=js"
export * from "./EditorPanel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrewderse/Documents/repos/gal-scroll-viewer-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__